module.exports = __webpack_public_path__ + "media/images/covid/banner/zh-hant-87cebfdf6ea5baa0708c8524c9dcda4e.jpg";